import { useSelector } from "react-redux";
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import Table from "../../../../../../common/components/table-manager/v1.1/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectListItems } from "../../../../../../redux/library/selector";
import PageLoader from "../../../../../../components/PageLoader";
import { logisticsOrders } from "../../../../../../redux/logistics-orders/action";
import { selectLogisticsOrdersListItems } from "../../../../../../redux/logistics-orders/selector";
import { FaGalacticSenate } from "react-icons/fa6";
import { journeys } from "../../../../../../redux/journey/action";
import { selectJourneyListItems } from "../../../../../../redux/journey/selector";


const ManagementLogisticsJourneys = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const libraryData = useSelector(selectListItems)
    const itemsData = useSelector(selectJourneyListItems)
    const [
        columnDefs,
        setColumnDefs
    ] = useState({});
    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'JourneyId', headerName: 'JourneyId', sortable: true ,searchField: 'Name', filter: true, filterType: 'number' },
            {
                field: 'ShippingStatusId', headerName: 'Shipping Status',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: { library: libraryData?.result?.ShippingStatus, isRowColorDecider: true },
                sortable: true,
                filter: false
            },
            {
                field: 'LogisticsOrderStatusId', headerName: 'order status',
                cellRenderer: 'libraryRendererComponent',
                cellRendererParams: {
                    library: libraryData?.result?.LogisticsOrderStatus, isRowColorDecider: true
                },
                sortable: true,
                filter: false
            },

            { field: 'CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'ModifiedOn', isDateValueFormat: true },
        ]);
    }
    const fetchLogisticsOrders = () => {
        dispatch(journeys.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/order-layer/journies/fetch`, entity: 'logisticsOrders', jsonData:
            {
                "Context": {},
                "Records": [{}],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "JourneyId",
                    "SortOrder": "desc",
                }
            }
        }))
    }

    useEffect(() => {
        createColumnDefs()
        fetchLogisticsOrders()
    }, [pageData, pageSize])

    // const handleAdd = () => {
    //   navigate(`${0}`)
    // }

    const handleDelete = (data: any) => {
        dispatch(journeys.delete({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/transport/logistics-orders/delete`,
            entity: 'journeys',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: data?.JourneyId
                    }
                ]
            }
        })).then(() => {
            fetchLogisticsOrders()

        });
    }

    const handleEdit = (data: any) => {
        navigate(`${data?.JourneyId}`)
    }
    const handleReloadData = () => {
        fetchLogisticsOrders()
    }
    const additionButtons: any = [

        {
            svg:
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
                    <title>Reload this table</title>
                    <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>,
            callback: () => handleReloadData(),
        },
    ];

    const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
            searchCriteria = [{
                FieldName: data?.column,
                FieldText: data?.column,
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        } else {
            searchCriteria = [{
                FieldName: "InvoiceNumber",
                FieldText: "InvoiceNumber",
                FieldType: 'text',
                FilterOperatorId: 6,
                FieldValue: data?.value
            }]
        }
        dispatch(journeys.list({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/logistics/order-layer/journies/fetch`,
            entity: 'journeys',
            jsonData:
            {
                "Context": {},
                "Records": [{}],
                "Pagination": {
                    "PageNumber": pageData,
                    "PageSize": pageSize,
                    "SortField": "JourneyId",
                    "SortOrder": "desc",
                    "isOrCondition": true,
                    "isFilterConditionOr": true,
                    "isSearchConditionOr": true,
                    "Searches": searchCriteria,

                }
            }
        }));
    }

    return (
        <>
            {itemsData?.isLoading ? <PageLoader />
                :
                <Table
                    columnData={columnDefs}
                    rowData={itemsData?.result?.items}
                    checkboxConfig={{
                        allowMultiSelect: true,
                        defaultSelectedIds: [],
                        isDisabled: false,
                        keyColumn: 'Name',
                    }}
                    setPageData={setPageData} setPageSize={setPageSize}
                    onSearch={handleSearch}
                    paginationData={itemsData?.result?.pagination}
                    enableFilter={true}
                    onEdit={handleEdit} additionButtons={additionButtons} onDelete={handleDelete} headingName="Journeys" />
            }
        </>

    );
};

export default ManagementLogisticsJourneys;


